export default function toCamelCase(str) {
  if (!str) return '';
  const clearString = str.replaceAll('*', '');
  return clearString.trim().toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, (m, chr) => chr.toUpperCase());
}
